import { useRef, useState } from "react";
import PricingManager from "./PricingManager";
import { ToastContainer } from "react-toastify";
import { LeftSide } from "./leftSide";
import CouponTable from "./CouponTable";
import CombineBundleTable from "./CombineBundleTable";

function AdminSettings() {
  const [tab, setTab] = useState("coupons");
  const couponTableRef = useRef(null);
  const bundleTableRef = useRef(null);

  const style = {
    ul: "flex space-x-0 mt-0 border-b border-gray-300",
    li: "text-gray-900 pb-2 px-3 hover:opacity-70 text-sm xl:text-base cursor-pointer",
    selected:
      "cursor-default border-b-4 border-blue-700 text-sm xl:text-base text-blue-700 pb-2 px-3 font-medium ",
  };

  const handleCreateClick = () => {
    if (tab === "coupons") {
      couponTableRef.current?.openCreateForm();
      return;
    }

    bundleTableRef.current?.openCreateForm();
  };

  return (
    <div className="p-4 h-full bg-gray-100 overflow-auto pb-28 md:pb-0">
      <div className="flex flex-col xl:flex-row lg:flex-row gap-4">
        <div className="w-full lg:w-2/4 xl:w-2/4">
          <LeftSide />
        </div>
        <div className="w-full lg:w-2/4 xl:w-2/4">
          <div className="flex h-auto">
            <PricingManager />

            <ToastContainer />
          </div>
          <div className="flex h-auto">
            <div className="w-full bg-white shadow-lg rounded-lg py-4 border-gray-300 px-4 mt-4">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-2">
                <h2 className="text-xl uppercase">
                  COUPONS &amp; COMBINE BUNDLES
                </h2>
                <button
                  type="button"
                  className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-800 text-white uppercase text-sm"
                  onClick={handleCreateClick}
                >
                  {tab === "coupons" ? "+ New Coupon" : "+ New Combine Bundle"}
                </button>
              </div>

              <div>
                <ul className={style.ul} role="tablist">
                  <li
                    className={tab === "coupons" ? style.selected : style.li}
                    role="tab"
                    tabIndex={0}
                    aria-selected={tab === "coupons"}
                    onClick={() => setTab("coupons")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setTab("coupons");
                      }
                    }}
                  >
                    Coupons
                  </li>
                  <li
                    className={
                      tab === "combineBundles" ? style.selected : style.li
                    }
                    role="tab"
                    tabIndex={0}
                    aria-selected={tab === "combineBundles"}
                    onClick={() => setTab("combineBundles")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setTab("combineBundles");
                      }
                    }}
                  >
                    Combine Bundles
                  </li>
                </ul>
              </div>

              <div className="my-6">
                {tab === "coupons" && <CouponTable ref={couponTableRef} />}
                {tab === "combineBundles" && (
                  <CombineBundleTable ref={bundleTableRef} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminSettings;
